'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  $('.header__lang-active').on('click', function () {
    $(this).closest('form').find('.header__lang-list').toggleClass('active');
  });

  $('.text-scroll').mCustomScrollbar();

  $('.tabs').each(function tabs() {
    // For each set of tabs, we want to keep track of
    // which tab is active and its associated content
    var $active = void 0;
    var $content = void 0;
    var $links = $(this).find('a');
    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($links.filter('[href="' + location.hash + '"]')[0] || $links[0]);
    $active.addClass('active');
    $content = $($active[0].hash);
    // Hide the remaining content
    $links.not($active).each(function hide() {
      $(this.hash).hide();
    });
    // Bind the click event handler
    $(this).on('click', 'a', function click(e) {
      // Make the old tab inactive.
      $active.parent('li').removeClass('active');
      $content.hide();
      // Update the variables with the new link and content
      $active = $(this);
      $content = $(this.hash);
      // Make the tab active.
      $active.parent('li').addClass('active');
      $content.show();

      // Prevent the anchor's default click action
      e.preventDefault();
    });
  });
};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/main.js
// module id = 3
// module chunks = 0